import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import styled from "styled-components";
import PermissionModal from "./PermissionModal";
import { Avatar, Carousel, Row, Col, Modal, message, Button, ExclamationCircleOutlined, UserOutlined, ProTableOt, Tag, useProTableOt, Form, DatePicker, Input, Card, Radio, Typography, Seperator } from '../ui/ot'
import dayjs from 'dayjs'
import { usePermissionGroup } from './controllers/permission_group_controller'
import { usePermissionLevel } from './controllers/permission_level_controller'
import { useStaffDiverge } from './controllers/staff_diverge_controller'
import { useCRUDController } from '../ui/classify_structure/CRUDController';
import { prefix } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faBan } from '@fortawesome/free-solid-svg-icons';

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => (value === "" || !value) ? { ...all } : { ...all, [key]: value }, {})
}
const PermissionsList = ({
    mode = "group"
    //group、all
}) => {
    const [form] = Form.useForm()
    const [search_date, set_search_date] = useState([])
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [custom_column, set_custom_column] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [role, set_role] = useState('');
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const { confirm } = Modal;
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)


    // const navigate = useNavigate();
    const titles = {
        '/cramSchool/admin/PermissionsList/All': '所有成員權限管理',
        // '/cramSchool/admin/PermissionsList/Admin': '管理端權限管理',
        '/cramSchool/admin/PermissionsList/Administration': '行政端權限管理',
        '/cramSchool/admin/PermissionsList/Teacher': '老師端權限管理',
    }


    const onSelect = (e) => {
        // navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
        if (e.key == '/cramSchool/admin/PermissionsList/Administration') {
            set_role('行政端')
        } else if (e.key == '/cramSchool/admin/PermissionsList/Teacher') {
            set_role('老師端')
        } else {
            set_role('')
        }
    }




    const [default_column, set_default_column] = useState([
        {
            title: '照片',
            sorter: false,
            disabled: true,
            key: "file_id",
            render: (text, record, index) => (<>
                <div
                    style={{
                        margin: 0,
                        maxHeight: '64px',
                        width: '64px',
                    }}
                >
                    <Carousel
                        autoplay
                    >
                        {record['file_url'] ? record['file_url'].map((tmp, index) => (<>
                            <div>
                                <Avatar size={64} src={tmp} />
                            </div>
                        </>)) : (<>
                            <div>
                                <Avatar size={64} icon={<UserOutlined />} />
                            </div>
                        </>)}
                    </Carousel>
                </div>
            </>),
        },
        // {
        //     title: '成員姓名與帳號',
        //     sorter: false,
        //     align: 'center',
        //     width: '15rem',
        //     disabled:true,
        //     key:'serial_name',
        //     render: (text, record, index) => (
        //         <>
        //             <Row gutter={8}>
        //                 {/* <Col>
        //                     {record.position_type == '行政端' ?
        //                         <>
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" ><g opacity="1" transform="translate(0 0)  rotate(0 24 24)"><path id="BG" fill-rule="evenodd" style={{ fill: "#7E84A3", transform: "translate(0 0)  rotate(0 24 24)", opacity: "1" }} d="M4,48L44,48C46.21,48 48,46.21 48,44L48,4C48,1.79 46.21,0 44,0L4,0C1.79,0 0,1.79 0,4L0,44C0,46.21 1.79,48 4,48Z " /><g opacity="1" transform="translate(8 12)  rotate(0 16 12)"><text><tspan x="0" y="18.56" font-size="16" line-height="0" fill="#FFFFFF" opacity="1" font-family="SourceHanSansCN-Heavy" letter-spacing="0" >行政</tspan></text></g></g></svg>
        //                         </>
        //                         :
        //                         <>
        //                             {record.position_type == '老師端' ?
        //                                 <>
        //                                     <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><g opacity="1" transform="translate(0 0)  rotate(0 24 24)"><path id="BG" fill-rule="evenodd" style={{ fill: "#336DFF", transform: "translate(0 0)  rotate(0 24 24)", opacity: "1" }} d="M4,48L44,48C46.21,48 48,46.21 48,44L48,4C48,1.79 46.21,0 44,0L4,0C1.79,0 0,1.79 0,4L0,44C0,46.21 1.79,48 4,48Z " /><g opacity="1" transform="translate(8 12)  rotate(0 16 12)"><text><tspan x="0" y="18.56" font-size="16" line-height="0" fill="#FFFFFF" opacity="1" font-family="SourceHanSansCN-Heavy" letter-spacing="0" >老師</tspan></text></g></g></svg>
        //                                 </>
        //                                 :
        //                                 <>
        //                                     <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" >
        //                                         <g opacity="1" transform="translate(0 0)  rotate(0 24 24)">
        //                                             <path id="BG" fill-rule="evenodd" style={{ fill: "#FF3392", transform: "translate(0 0)  rotate(0 24 24)" }} opacity="1" d="M4,48L44,48C46.21,48 48,46.21 48,44L48,4C48,1.79 46.21,0 44,0L4,0C1.79,0 0,1.79 0,4L0,44C0,46.21 1.79,48 4,48Z " />
        //                                             <g opacity="1" transform="translate(8 12)  rotate(0 16 12)">
        //                                                 <text>
        //                                                     <tspan x="0" y="18.56" font-size="16" line-height="0" fill="#FFFFFF" opacity="1" font-family="SourceHanSansCN-Heavy" letter-spacing="0" >管理</tspan>
        //                                                 </text>
        //                                             </g>
        //                                         </g>
        //                                     </svg>
        //                                 </>
        //                             }
        //                         </>
        //                     }
        //                 </Col> */}
        //                 <Col>
        //                     <Tag color='geekblue'>
        //                         {record?.position_type}

        //                     </Tag>
        //                 </Col>
        //                 <Col style={{ textAlign: 'left' }}>
        //                     <Space wrap><>姓名:</><>{record.name}</></Space>
        //                     <Space wrap><>帳號:</><>{record.serial_name}</></Space>
        //                 </Col>
        //             </Row>
        //         </>
        //     )
        // },
        {
            title: '姓名',
            key: 'staff_name',
            dataIndex: 'staff_name',
            align: 'center',
        },
        {
            title: '帳號',
            key: 'uid',
            dataIndex: 'uid',
            align: 'center',
        },
        {
            title: '可編輯頁面',
            key: '可編輯頁面',
            dataIndex: '可編輯頁面',
            sorter: false,
            disabled: true,
            render: (text, record, index) => (
                <Row gutter={[16, 16]}>
                    {
                        record.user_permission_data?.filter((item) => item.permission_level_id === 1)?.filter((_, index) => index < 6).map((value) => {
                            return (
                                <Col>
                                    <Tag color='gold-inverse' >{value.permission_name}</Tag>
                                </Col>
                            )
                        })
                    }
                    {record.user_permission_data?.filter((item) => item.permission_level_id === 1)?.length > 7 && <>
                        <Button type={'text'} size={'small'}
                            onClick={() => {
                                Modal.confirm({
                                    title: '權限清單',
                                    okText: '確定',
                                    okType: 'primary',
                                    cancelText: '取消',
                                    content: <>
                                        <Row gutter={[16, 16]}>

                                            {
                                                record.user_permission_data.map((value) => {
                                                    return (
                                                        <Col>
                                                            <Tag color='gold-inverse' >{value.permission_name}</Tag>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    </>,
                                    centered: true,
                                    width: 1000
                                });
                            }}
                        >顯示更多</Button>
                    </>}
                </Row>
            ),
            width: '30rem',
            align: 'center',
        },
        {
            title: '僅可檢視頁面',
            key: '僅可檢視頁面',
            dataIndex: '僅可檢視頁面',
            sorter: false,
            disabled: true,
            render: (text, record, index) => (
                <Row gutter={[16, 16]}>
                    {
                        record.user_permission_data?.filter((item) => item.permission_level_id === 2)?.filter((_, index) => index < 6).map((value) => {
                            return (
                                <Col>
                                    <Tag color='gold-inverse' >{value.permission_name}</Tag>
                                </Col>
                            )
                        })
                    }
                    {record.user_permission_data?.filter((item) => item.permission_level_id === 2)?.length > 7 && <>
                        <Button type={'text'} size={'small'}
                            onClick={() => {
                                Modal.confirm({
                                    title: '權限清單',
                                    okText: '確定',
                                    okType: 'primary',
                                    cancelText: '取消',
                                    content: <>
                                        <Row gutter={[16, 16]}>

                                            {
                                                record.user_permission_data.map((value) => {
                                                    return (
                                                        <Col>
                                                            <Tag color='gold-inverse' >{value.permission_name}</Tag>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    </>,
                                    centered: true,
                                    width: 1000
                                });
                            }}
                        >顯示更多</Button>
                    </>}
                </Row>
            ),
            width: '30rem',
            align: 'center',
        },
        // {
        //     title: '權限',
        //     key: 'role_permission',
        //     dataIndex: 'role_permission',
        //     render: (text, record, index) => (
        //         <>
        //             {
        //                 record.role_permission && record.role_permission.map((value) => {
        //                     return (
        //                         <>
        //                             <Tag>{value.permission_name}</Tag>
        //                         </>
        //                     )
        //                 })
        //             }
        //         </>
        //     ),
        //     width: '40%',
        //     align: 'center',
        // },
        {
            title: '使用起始日',
            key: 'employment_time_start',
            dataIndex: 'employment_time_start',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                let first = record.user_permission_data.find((ele) => true)
                return (<Row>
                    <Col>
                        <Tag color='cyan-inverse' >{first?.permission_time_start}</Tag>
                    </Col>
                </Row>)
            }
        },
        {
            title: '使用結束日',
            key: 'employment_time_end',
            dataIndex: 'employment_time_end',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                let first = record.user_permission_data.find((ele) => true)
                return (<Row>
                    <Col>
                        <Tag color='cyan-inverse' >{first?.permission_time_end}</Tag>
                    </Col>
                </Row>)
            }
        },
        {
            title: '操作',
            key: 'operation',
            dataIndex: 'operation',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (
                <>
                    {/* <button type="button" className="btn btn-link text-success" onClick={e => handleOnShow(record)}>修改</button>
                        <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button> */}
                    <Button type="text"
                        style={{ color: 'rgba(43, 193, 123, 1)' }}
                        onClick={e => {
                            editRow(record)
                        }
                        }>
                        修改
                    </Button>
                    {/* <Button danger type="text" onClick={() => showMessage(record.administration_id)}>刪除</Button> */}
                </>
            )
        },
        /* {
                            title: '',
            render: (text, record, index) => <button type="button" className="btn btn-link text-success" onClick={e => handleOnDelete(record.Pid)}>刪除</button>
        } */
    ])
    const editRow = (record) => {
        let first = record.user_permission_data.find((ele) => true)

        setTitle('修改');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);

        setEditCard({
            ...record,
            permission_time_start: first?.permission_time_start,
            permission_time_end: first?.permission_time_end
        })
    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/permission/manage`, {
                data: [{ serial_name: value }]
            })
            .then((response) => {
                // console.log(response)
                if (response.data.status != 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    reload();
                }
            })
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        let params = {};
        params = {
            cur_page: param?.current,
            size: param?.pageSize,
            custom_filter_key: checklist,
            custom_filter_value: param?.keyword,
            permission_time_start: search_date[0],
            permission_time_end: search_date[1],
            order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
        }
        params = setParamsFilter(params)
        return axios
            .get('/organization_structure/api/staff_diverge', {
                params: params,

            })
            .then((response) => {
                set_total(response.data.total || 0)
                setDatas(response.data.data || []);
                if (response.data.data) {
                    get_picture(response.data.data);
                }
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let serial_name = value['serial_name']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (serial_name == value.serial_name) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'permission',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'permission'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        reload()
    }, [search_date])
    useEffect(() => {
        getData();
    }, []);
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'serial_name': value })
            })
            // console.log(deleterow)
            axios
                .delete(`/cramSchool/api/permission/manage`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnAddRow = () => {
        setTitle('新增');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
    }
    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleEdit = () => {
        if (editcard['user_permission_data'].length === 0) {
            messageApi.open({
                type: 'warning',
                content: '請勾選人員權限管理',
            });
        } else {
            axios
                .patch(`/organization_structure/api/staff_diverge`, [
                    {
                        ...editcard,
                        user_permission_data: editcard.user_permission_data.map(map_item => (
                            {
                                ...map_item,
                                permission_time_start: editcard.permission_time_start,
                                permission_time_end: editcard.permission_time_end
                            }
                        ))
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                        actionRef.current.reload()
                        // reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        actionRef.current.reload()
                        // reload();
                    }
                })
        }
    }
    const handleSubmit = () => {
        axios
            .post(`/cramSchool/api/permission/manage`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                    getData();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    getData();
                }
            })
    }
    const cancel = () => {
        setOpen(false)
    }
    const onFormFinish = ({

    }) => {
        const values = form.getFieldsValue()
        patchStaffDivergeData([{
            user_id: values?.user_id,
            user_permission_data: Object.entries(values?.user_permission_data)?.map(([key, value]) => {
                return {
                    user_id: values?.user_id,
                    permission_id: key,
                    permission_level_id: value,
                    permission_time_start: dayjs(values?.permission_time_start).format('YYYY-MM-DD'),
                    permission_time_end: dayjs(values?.permission_time_end).format('YYYY-MM-DD')
                }
            }).filter(item => item?.permission_level_id)
        }])
    }

    const {
        patchStaffDivergeData
    } = useStaffDiverge({
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === 'patch') {
                if (status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    actionRef.current.reload()
                    // reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    actionRef.current.reload()
                    // reload();
                }
            }
        }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns: default_column.concat(extra_columns || [])
    })
    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
        // console.log(data)
        datas.forEach(each_item => {
            if (each_item.serial_name === editcard.serial_name) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [datas])
    return (
        <>
            {mode === "all" && <>
                <PermissionModal
                    open={open}
                    edit={edit}
                    title={title}
                    color={color}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    setOpen={setOpen}
                    handleEdit={handleEdit}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                />
            </>}
            {mode === "group" && <>
                <PermissionListModal
                    axiosMode="post"
                    propsForm={form}
                    propsOpen={open}
                    propsLoading={loading}
                    propsSetOpen={setOpen}
                    onFinish={onFormFinish}
                    editcard={editcard}
                />
            </>}


            <Col span={24} style={{ paddingTop: '10px' }}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={default_column}
                    check={check}
                    setCheck={setCheck}
                    rowKey={'key'}
                    selections={{
                        // onChange: (index_, data_) => set_data(data_)
                    }}
                    toolBarRender={() => [
                        // <Popconfirm
                        //     title="刪除消息"
                        //     description="確定刪除勾選消息?"
                        //     onConfirm={() => handleDeleteRow()}
                        //     onCancel={() => { }}
                        // >
                        //     <Button
                        //         type='primary'
                        //         style={{
                        //             color: "#000",
                        //             backgroundColor: "#ffedee"
                        //         }}

                        //     >
                        //         刪除消息
                        //     </Button>
                        // </Popconfirm>
                    ]}
                    // extra_columns={extra_columns}
                    // set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)
                        // // return getNewsData(newParams)
                        // // set_loading(true);
                        // let params = {};
                        // params = {
                        //     cur_page: param?.current,
                        //     size: param?.pageSize,
                        //     custom_filter_key: checklist,
                        //     custom_filter_value: param?.keyword,
                        //     order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                        // }
                        // params = setParamsFilter(params)
                        return axios
                            .get('/organization_structure/api/staff_diverge', {
                                params: newParams,

                            })
                            .then((response) => {
                                // set_total(response.data.total || 0)
                                // setDatas(response.data.data || []);
                                // if (response.data.data) {
                                //     get_picture(response.data.data);
                                // }
                                return {
                                    ...response.data
                                }
                            })
                            .finally(() => {
                                // set_loading(false)
                            })
                    }}
                    pageSize={pageSize}
                    // rowSelection={{
                    //     type: 'checkbox',
                    //     selectedRowKeys: selectedRowKeys,
                    //     ...rowSelection,
                    // }}
                    rowSelection={false}
                    tableAlertOptionRender={() => {
                        return (<></>)
                    }}
                    // tableAlertRender={({
                    //     selectedRowKeys,
                    //     selectedRows,
                    //     // onCleanSelected,
                    // }) => {
                    //     return (
                    //         <Space size={24}>
                    //             <span>
                    //                 已選擇 {selectedRowKeys.length} 項
                    //                 <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                    //                     取消選擇
                    //                 </a>
                    //             </span>
                    //         </Space>
                    //     );
                    // }}
                    scroll={{
                        x: "90vw"
                    }}

                />
                {/* <NewTable
                    force_reload={force_reload}
                    total={total}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    loading={loading}
                    page_name={'PermissionList'}
                    columns={default_column.concat(extra_columns || [])}
                    getData={getData}
                    datas={datas}//table資料
                    // add_button_title={'新增人員'}//新增按鈕上的名稱
                    // handleOnAddRow={handleOnAddRow}//新增row 內容
                    add={false}
                    rowkey={'staff_id'}//key

                // setSelectedRowKeys={setSelectedRowKeys}
                // selectedRowKeys={selectedRowKeys}
                // handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                // rangepicker_title={'起始時間'}
                // handleSearchDate={handleSearchDate}//搜尋日期
                ></NewTable> */}
            </Col>
        </>
    )
};
export default PermissionsList;
export { PermissionListModal, PermissionListForm }


const CollapseContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  ${'' /* width: 100%; */}
  ${'' /* max-width: 400px; */}
  ${'' /* margin: 10px auto; */}
  `;

const CollapseHeader = styled.div`
  background-color: #f5f5f5;
  padding: 10px 15px;
  ${'' /* font-size: 16px; */}
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: #e9e9e9;
  }
`;

const CollapseContent = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? "500px" : "0")};
  transition: max-height 0.3s ease;
  background-color: #fff;
  font-size: 14px;
  color: #333;
`;

const Icon = styled.span`
  transform: rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});
  transition: transform 0.3s ease;
`;

const PermissionListModal = (
    {
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        editcard,
        id,
        prefix,
        apiRoute,
        ...props
    }
) => {
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                setLoading(false)
                return
            } else if (axiosMode === "post") {
                message.success("新增成功");

            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
            propsSetOpen(false)
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }

    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const onFormFinish = (values) => {
        let formValues = values
        formValues[prefix + '_id'] = id
        formValues[prefix + '_permission_data'] = Object.entries(values?.[prefix + '_permission_data'])?.map(([key, value]) => {
            return {
                [prefix + '_id']: id,
                permission_id: key,
                permission_level_id: value,
                permission_time_start: dayjs(values?.permission_time_start).format('YYYY-MM-DD'),
                permission_time_end: dayjs(values?.permission_time_end).format('YYYY-MM-DD')
            }
        }).filter(item => item?.permission_level_id)
        permissionController.patchData([formValues])
    }


    const permissionController = useCRUDController({
        onFinish,
        onBefore,
        apiRoute: apiRoute
    })

    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    useEffect(() => {
        // console.log(id)
        if (propsOpen) {
            permissionController.getData({ [prefix + '_id']: id })
        }
    }, [propsOpen])
    return <>
        {
            propsOpen === null &&
            <Button type="primary" onClick={showModal}>
                {
                    `權限項目編輯`
                }
            </Button>
        }

        <Modal
            style={{ top: 10 }}
            title={`權限項目編輯`}
            open={propsOpen === null ? isModalOpen : propsOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={propsLoading === null ? loading : propsLoading}
            maskClosable={false}
            contentStyle={{
                padding: 16
            }}
            width={1000}
            okText={'送出'}
            cancelText={'取消'}
        >
            <Row>
                <Col span={24}>
                    <PermissionListForm
                        formReloadCount={formReloadCount}
                        open={propsOpen === null ? isModalOpen : propsOpen}
                        axiosMode={axiosMode}
                        propsForm={propsForm ? propsForm : form}
                        onFormFinish={onFormFinish}
                        editcard={permissionController.ResponseData.find(_ => true)}
                        prefix={prefix}
                    />
                </Col>
            </Row>
        </Modal>
    </>
}
const PermissionListForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
        editcard,
        prefix = ''
    }
) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    };
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getPermissionGroupData()
        getPermissionLevelData()
        if (editcard) {
            setFormValuesOtherThings({
                [prefix + '_id']: editcard?.[prefix + '_id'],
                permission_time_start: editcard?.permission_time_start || dayjs().format('YYYY-MM-DD'),
                permission_time_end: editcard?.permission_time_end || dayjs().format('YYYY-MM-DD'),
            })

            editcard?.[prefix + '_permission_data']?.forEach(item => {
                setFormValuesOtherThings({ [prefix + "_permission_data." + item?.permission_id]: String(item?.permission_level_id) })
            })
        }
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({ minutes })
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    const {
        PermissionGroupData,
        getPermissionGroupData
    } = usePermissionGroup({})

    const {
        PermissionLevelData,
        getPermissionLevelData
    } = usePermissionLevel({})

    useEffect(() => {
        setDataInitialization()
    }, [editcard])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Form
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]} justify={'end'}>
                        <Col>
                            <Button type={'text'} style={{ color: 'blue' }}
                                onClick={() => {

                                    PermissionGroupData?.forEach(mapItem => {
                                        mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                            (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '1' })
                                        })
                                    })

                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                                全部可編輯</Button>
                        </Col>
                        <Col>
                            <Button type={'text'} style={{ color: 'black' }}
                                onClick={() => {

                                    PermissionGroupData?.forEach(mapItem => {
                                        mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                            (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '2' })
                                        })
                                    })

                                }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                                全部僅檢視</Button>
                        </Col>
                        <Col>
                            <Button type={'text'} style={{ color: 'red' }}
                                onClick={() => {

                                    PermissionGroupData?.forEach(mapItem => {
                                        mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                            (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '' })
                                        })
                                    })

                                }}
                            >

                                <FontAwesomeIcon icon={faBan} />
                                全部無權限</Button>
                        </Col>
                    </Row>
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={`${prefix}_id`}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            {PermissionGroupData?.map(mapItem => {
                                return (
                                    <Row gutter={[8, 8]}
                                        style={{
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            overflow: 'hidden',
                                            marginBottom: '1rem',
                                        }}>
                                        <Col span={24}
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                fontWeight: 'bold',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <Row gutter={[8, 8]}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                <Col
                                                    xxl={12}
                                                    xl={12}
                                                    lg={12}
                                                    md={12}
                                                    xs={24}
                                                >
                                                    <Row gutter={[8, 8]}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}>
                                                        <Col>
                                                            <Button
                                                                type={'text'}
                                                                style={{ color: !isOpen ? '#257180' : '#697565' }}
                                                                onClick={toggleCollapse}
                                                            >
                                                                {!isOpen ? "展開項目" : "關閉項目"}
                                                            </Button>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Title level={4}>{mapItem?.permission_group_name}</Typography.Title>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col
                                                    xxl={12}
                                                    xl={12}
                                                    lg={12}
                                                    md={12}
                                                    xs={24}
                                                >
                                                    <Row gutter={[8, 8]} justify={'end'} >
                                                        <Col>
                                                            <Button
                                                                type={'text'} style={{ color: 'blue' }}
                                                                onClick={() => {
                                                                    mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                                                        (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '1' })
                                                                    })
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                                可編輯</Button>
                                                        </Col>
                                                        <Col>
                                                            <Button
                                                                type={'text'} style={{ color: 'black' }}
                                                                onClick={() => {
                                                                    mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                                                        (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '2' })
                                                                    })
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                                僅檢視</Button>
                                                        </Col>
                                                        <Col>
                                                            <Button
                                                                type={'text'} style={{ color: 'red' }}
                                                                onClick={() => {
                                                                    mapItem?.permission_data?.forEach((mapItemItem, mapItemIndex) => {
                                                                        (propsForm ? propsForm : form)?.setFieldsValue({ [prefix + '_permission_data.' + mapItemItem?.permission_id]: '' })
                                                                    })
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faBan} />
                                                                無權限</Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col
                                            span={24}
                                            isOpen={isOpen}
                                            style={{
                                                maxHeight: isOpen ? "500px" : "0",
                                                overflow: 'scroll',
                                                backgroundColor: '#fff',
                                                fontSize: '14px',
                                                color: '#333'
                                            }}
                                        >
                                            <Row gutter={[8, 8]}>
                                                {mapItem?.permission_data?.map((mapItemItem, mapItemIndex) => {
                                                    return <>
                                                        <Col
                                                            span={24}
                                                            style={{
                                                                padding: '0.3rem'
                                                            }}
                                                        >
                                                            <Row gutter={[8, 8]}>
                                                                <Col span={12}
                                                                    style={{
                                                                        fontSize: 'medium'
                                                                    }}>
                                                                    {mapItemItem?.permission_name}
                                                                </Col>
                                                                <Col span={12}                                                                >
                                                                    <Form.Item
                                                                        name={`${prefix}_permission_data.` + mapItemItem?.permission_id}
                                                                        labelCol={0}
                                                                    >
                                                                        <Radio.Group
                                                                            defaultValue={''}
                                                                        >
                                                                            <Row gutter={[8, 8]}>
                                                                                {PermissionLevelData?.map(mapItemItem => {
                                                                                    return <>
                                                                                        <Col
                                                                                            xxl={8}
                                                                                            xl={8}
                                                                                            lg={8}
                                                                                            md={12}
                                                                                            xs={24}
                                                                                        >
                                                                                            <Radio value={String(mapItemItem?.permission_level_id)}>{mapItemItem?.permission_level_name}</Radio>
                                                                                        </Col>
                                                                                    </>
                                                                                })}
                                                                                <Col
                                                                                    xxl={8}
                                                                                    xl={8}
                                                                                    lg={8}
                                                                                    md={12}
                                                                                    xs={24}
                                                                                >

                                                                                    <Radio value={''}>{'無權限'}</Radio>
                                                                                </Col>
                                                                            </Row>

                                                                        </Radio.Group>
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </>
                                                })}
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            })}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
